import React from "react";
import {Button} from "react-bootstrap";
import "tippy.js/dist/tippy.css";
import Tooltip from "../tooltip/Tooltip";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const IconButtonFontawesome = ({variant, icon, className, show = true, tooltip, size, onClick, disabled, fullIcon, text}) => {

    return (
        <>
            {show &&
                <Tooltip tooltip={tooltip}>
                    <Button variant={variant}
                            size={size ? size : "md"}
                            disabled={disabled}
                            className={className + " icon-button"}
                            role="button"
                            onClick={onClick}>
                        <FontAwesomeIcon icon={icon} />
                        {text}
                    </Button>
                </Tooltip>
            }
        </>
    );
};


export default IconButtonFontawesome;